import { create } from 'zustand';

interface DialogOptions {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'default' | 'danger';
  defaultValue?: string;
  placeholder?: string;
}

interface DialogState {
  isOpen: boolean;
  type: 'confirm' | 'prompt' | null;
  options: DialogOptions | null;
  resolve: ((value: boolean | string | null) => void) | null;
}

interface DialogStore extends DialogState {
  confirm: (options: Omit<DialogOptions, 'defaultValue' | 'placeholder'>) => Promise<boolean>;
  prompt: (options: DialogOptions) => Promise<string | null>;
  close: (result: boolean | string | null) => void;
}

export const useDialogStore = create<DialogStore>((set, get) => ({
  isOpen: false,
  type: null,
  options: null,
  resolve: null,

  confirm: (options) => {
    return new Promise<boolean>((resolve) => {
      set({
        isOpen: true,
        type: 'confirm',
        options: { confirmLabel: 'Conferma', cancelLabel: 'Annulla', variant: 'default', ...options },
        resolve: (value) => resolve(value as boolean),
      });
    });
  },

  prompt: (options) => {
    return new Promise<string | null>((resolve) => {
      set({
        isOpen: true,
        type: 'prompt',
        options: { confirmLabel: 'Conferma', cancelLabel: 'Annulla', ...options },
        resolve: (value) => resolve(value as string | null),
      });
    });
  },

  close: (result) => {
    const { resolve } = get();
    resolve?.(result);
    set({ isOpen: false, type: null, options: null, resolve: null });
  },
}));
